import {SLUGS} from '@px/const/slugs';
import {appendTemplates} from '@px/helper/template';

export const templates: Template[] = [
  {
    slug: SLUGS.BROKER_DASHBOARD,
    loader: () => import('px-home/src/modules/broker/dashboard'),
  },
  {
    slug: SLUGS.BROKER_TRADERS,
    loader: () => import('px-home/src/modules/broker/traders'),
  },
  {
    slug: SLUGS.BROKER_COMMISSIONS_CONTRACT,
    loader: () => import('px-home/src/modules/broker/commissions/contract'),
  },
  {
    slug: SLUGS.BROKER_COMMISSIONS_SPOT,
    loader: () => import('px-home/src/modules/broker/commissions/spot'),
  },
  {
    slug: SLUGS.BROKER_ASSETS,
    loader: () => import('px-home/src/modules/broker/assets'),
  },
  {
    slug: SLUGS.BROKER_USER_INFO,
    loader: () => import('px-home/src/modules/broker/user-info'),
  },
  {
    slug: SLUGS.BROKER_INDEX,
    loader: () => import('px-home/src/modules/broker/index'),
  },
];

appendTemplates(templates);
